export default {
  regionalRiskAssessment: {
    eudrDueDiligence: "EUDR Due Diligence",
    title: "Regionale Risicobeoordeling",
    titleTT: "Landenbenchmarking in de regionale risicobeoordeling van EUDR",
    details: "Details",
    detailsTT: "Uitvouwen om gedetailleerde criteria en referenties te bekijken die verband houden met de classificatie van hoog risico, met focus op ontbossing, inheemse rechten, corruptie en mensenrechtenkwesties.",
    createNewCountryReport: "Nieuw Landenrapport Maken",
    updateCountryReport: "Landrapport Bijwerken",
    duplicateCountryReport: "Landrapport Dupliceren",
    search: "Zoeken",
    country: "Land",
    dateCreated: "Aanmaakdatum",
    edit: "Bewerken",
    delete: "Verwijderen",
    duplicate: "Dupliceren",
    actions: "Acties",
    submit: "Verzenden",
    save: "Opslaan",
    cancel: "Annuleren",
    selectCountry: "Selecteer Land",
    riskAssessmentCriteria: "Criteria voor Risicobeoordeling",
    riskLevel: "Risiconiveau",
    unassigned: "Niet Toegewezen",
    standard: "Standaard",
    standardToHigh: "Standaard naar Hoog",
    high: "Hoog",
    reportDetails: "Rapportdetails",
    select: "Selecteren",
    requiredFields: "Dit veld is verplicht",
    pleaseFillRequiredFields: "Vul alle verplichte velden in",
    createCuccess: "Regionale risicobeoordeling succesvol aangemaakt",
    updateSuccess: "Regionale risicobeoordeling succesvol bijgewerkt",
    createError: "Fout bij het aanmaken van regionale risicobeoordeling",
    updateError: "Fout bij het bijwerken van regionale risicobeoordeling",
    deleteSuccess: "Regionale risicobeoordeling succesvol verwijderd",
    duplicateSuccess: "Regionale risicobeoordeling succesvol gedupliceerd",
    deleteRegionalRisk: "Verwijder Regionale Risicobeoordeling",
    confirmDelete: "Weet u zeker dat u deze regionale risicobeoordeling wilt verwijderen?",
    confirm: "Bevestigen",
    saveSuccess: "Regionale risicobeoordeling succesvol opgeslagen",
    fetchError: "Fout bij het ophalen van regionale risicobeoordeling",
    disregard: "Negeer Segmenten",
    addRegionalRiskAssessment: "Voeg Regionale Risicobeoordeling Toe",
    summary: "Samenvatting",
    summaryTT: "Dit gedeelte beschrijft de toegekende risiconiveaus op basis van uitgebreide gegevens en referenties.",
    summaryText: "De risicobeoordeling van het land zal het land van de boerderij classificeren volgens de volgende risiconiveaus (Hoog, Standaard en Zero/Neegeerbaar) op basis van verifieerbare referenties, informatie, documenten en gegevens. Resultaten die anders zijn dan 'Zero/Neegeerbaar' geven aan dat er een risicobeperkingsactie (RMA) nodig is om 'Zero/Neegeerbaar Risico' te waarborgen. Tabel 1 toont de algemene resultaten van de risicobeoordeling voor (country). De volledige risicobeoordeling van het land is bijgevoegd bij dit document in Bijlage III.",
    disregardConfirmTitle: "Negeer Enig Segment of Alle",
    selectSegment: "Selecteer segmenten om te negeren.",
    addConfirmTitle: "Voeg Elk Segment of Alle Segmenten Toe",
    deselectToAddSegment: "Deselecteer segmenten om toe te voegen.",
    all: "Alle",
    protectedAreas: "Beschermde & Inheemse Gebieden",
    verificaton: "Verificatie met de Braziliaanse Overheidsdatabase",
    confirmation: "Bevestiging",
    confirmationMessage: "Weet u zeker dat u de regionale risicobeoordeling wilt negeren? Het bevestigen van deze actie resulteert in het verwijderen van de regionale risicobeoordeling uit het due diligence-rapport.",
    noSegmentSelectedMessage: "Er is geen segment geselecteerd. Selecteer een segment om verder te gaan.",
    singleRiskAssessmentCriteriaMessage: "Weet u zeker dat u de Regionale Risicobeoordelingscriteria wilt toevoegen of verwijderen? Het bevestigen van deze actie zal het due diligence-rapport bijwerken.",
    singleProtectedAreasMessage: "Weet u zeker dat u de Beschermde en Inheemse Gebieden wilt toevoegen of verwijderen? Het bevestigen van deze actie zal het due diligence-rapport bijwerken.",
    bothSegmentsMessage: "Weet u zeker dat u zowel de Regionale Risicobeoordelingscriteria als de Beschermde en Inheemse Gebieden wilt toevoegen of verwijderen? Het bevestigen van deze actie zal het due diligence-rapport bijwerken.",
    segmentsUpdatedSuccessfully: "Segmenten succesvol bijgewerkt"

  }
}
